import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Field, formValueSelector, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import MdKeyboardArrowRight from 'react-icons/lib/md/keyboard-arrow-right';
import MdKeyboardArrowDown from 'react-icons/lib/md/keyboard-arrow-down';
import MdExitToApp from 'react-icons/lib/md/exit-to-app';
import addressPropTypes from '../../../../shared/CommonPropTypes/address';

import IOSLoader from '../../../../shared/components/IOSLoader/IOSLoader';
import formSteps from '../../../../shared/helpers/formSteps';
import getEnvironmentSuffix from '../../../../shared/helpers/getEnvironmentSuffix';
import safeTemplateString from '../../../../shared/helpers/safeTemplateString';
import {
  getCity,
  getCountry,
  getCounty,
  getPostal,
  getProvince,
  getRoute,
  getStreetNumber,
} from '../../../../shared/libs/parse-google-autocomplete';
import {
  required,
  validateLatitude,
  validateLongitude,
} from '../../../../shared/libs/reduxFormValidations';
import CompanyName from '../../CompanyName/CompanyName';

import AddressInput from '../../FormElements/AddressInput/AddressInput';
import CoordinatesInput from '../../FormElements/CoordinatesInput/CoordinatesInput';
import InputText from '../../FormElements/Input/Input';

import './FirstScreen.scss';
import LocationService from '../../FormElements/LocationService/LocationService';
import coverageAreaValidation from './coverageAreaValidation';

class FirstScreen extends Component {
  constructor() {
    super();
    this.state = {
      isFocused: false,
      isEditOpen: false,
    };
    this.toggleFocus = this.toggleFocus.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
  }

  toggleFocus(isFocused = false) {
    this.setState({ isFocused });
  }

  toggleEdit(isEditOpen) {
    if (isEditOpen === 'toggle') {
      this.setState((prev) => ({ isEditOpen: !prev.isEditOpen }));
      return;
    }
    this.setState({ isEditOpen });
  }

  render() {
    const {
      match,
      history,
      invalid,
      pristine,
      change,
      config,
      companyName,
      brandingColor,
      logoUrl,
      requireCoverage,
      handleSubmit,
      addNextStep,
      asyncValidating,
      asyncValidate: av,
      latitude,
      longitude,
      address,
    } = this.props;
    const { isFocused, isEditOpen } = this.state;
    const openClass = isFocused || isEditOpen ? '-open' : '';
    const isEdit = isEditOpen ? '-edit' : '';
    const editIcon = isEditOpen ? (
      <MdKeyboardArrowDown width={20} height={20} />
    ) : (
      <MdKeyboardArrowRight width={20} height={20} />
    );
    return (
      <div className="container-fluid order_form_first">
        <div className="row">
          <div className="col">
            <div className="order_form_first__header_row row">
              {logoUrl ? (
                <div className="company-logo">
                  <img src={logoUrl} alt={`${companyName} logo`} />
                </div>
              ) : (
                <div className="company-logo-rectangle">
                  <CompanyName
                    companyName={companyName}
                    companyColor={brandingColor}
                  />
                </div>
              )}
            </div>
          </div>
          {!window.isAuthenticated && (
            <div className="col-auto ml-auto d-flex">
              <a
                href={`https://login${getEnvironmentSuffix()}.anow.com/?returnUrl=${
                  window.location.href
                }`}
                className="btn btn-link btn-lg mt-auto mb-auto"
              >
                <MdExitToApp size={25} className="mr-1" />
                Login
              </a>
            </div>
          )}
        </div>
        <div className="order_form_first__body row text-center align-items-center align-self-center">
          <div className="order_form_first__wrapper col-12 col-sm-9 offset-sm-1 col-md-6 offset-md-3">
            <div className="row">
              <div className="col-12">
                <h1 className="order_form_first__title">
                  Please enter the property address.
                </h1>
              </div>
            </div>
            <form id="wizard-form" onSubmit={handleSubmit}>
              {requireCoverage && (
                <div className="row">
                  <div className="col-12">
                    <Field name="location" component={LocationService} />
                  </div>
                </div>
              )}
              <div className="row">
                <div
                  className={`col-12 order_form_first__address_input order_form_first__address_input${openClass}`}
                >
                  <Field
                    name="googleAddress"
                    type="text"
                    component={AddressInput}
                    placeholder="Start typing..."
                    bemClass="order_form_first__address_input"
                    onFocus={() => this.toggleFocus(true)}
                    onAddressSubmit={(place) => {
                      if (typeof place === 'string') {
                        return;
                      }
                      const streetNumber = place.address_components.find(
                        getStreetNumber,
                      );
                      const route = place.address_components.find(getRoute);
                      const city = place.address_components.find(getCity);
                      const state = place.address_components.find(getProvince);
                      const zip = place.address_components.find(getPostal);
                      const country = place.address_components.find(getCountry);
                      const county = place.address_components.find(getCounty);
                      change('googleAddress', place.formatted_address);
                      if (streetNumber || route) {
                        change(
                          'address.address1',
                          `${
                            streetNumber
                              ? safeTemplateString(streetNumber.short_name)
                              : ''
                          } ${
                            route ? safeTemplateString(route.short_name) : ''
                          }`,
                        );
                      }
                      if (city) {
                        change('address.city', city.short_name);
                      }
                      if (zip) {
                        change('address.zipCode', zip.short_name);
                      }
                      if (state) {
                        change('address.state', state.short_name);
                      }
                      if (country) {
                        change('address.country', country.short_name);
                      }
                      if (county) {
                        change('address.county', county.short_name);
                      }
                      if (place && place.geometry && place.geometry.location) {
                        change('latitude', place.geometry.location.lat());
                        change('longitude', place.geometry.location.lng());
                        if (requireCoverage) {
                          setTimeout(av);
                        }
                      }
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      addNextStep(1);
                      history.push(
                        `/${match?.params?.companyName}${formSteps[1]}`,
                      );
                    }}
                    disabled={
                      invalid
                      || pristine
                      || (asyncValidating && requireCoverage)
                    }
                    className="order_form_first__next_btn btn btn-success"
                  >
                    {asyncValidating ? (
                      <IOSLoader />
                    ) : (
                      <span>
                        Next
                        <TiArrowRight
                          style={{ marginTop: '-4px', marginLeft: '2px' }}
                        />
                      </span>
                    )}
                  </button>
                  <div
                    className={`order_form_first__edit_address order_form_first__edit_address${openClass} order_form_first__edit_address${isEdit}`}
                  >
                    <button
                      type="button"
                      className={`btn btn-outline-dark order_form_first__edit_btn${isEdit}`}
                      onClick={() => this.toggleEdit('toggle')}
                    >
                      {editIcon}
                      Edit Address / Add Unit
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-left">
                  <div
                    className={`order_form_first__address_details order_form_first__address_details${isEdit}`}
                  >
                    <div className="row">
                      <div className="col-6">
                        <Field
                          name="address.address1"
                          type="text"
                          label="Address Line 1"
                          component={InputText}
                          placeholder="Required"
                          required={config.address1?.r}
                          validate={[].concat(
                            config.address1?.r ? [required] : [],
                          )}
                          hidden={config.address1?.h}
                        />
                      </div>
                      <div className="col-6">
                        <Field
                          name="address.address2"
                          type="text"
                          label="Address Line 2"
                          component={InputText}
                          placeholder="Unit, Suite, etc"
                          required={config.address2?.r}
                          validate={[].concat(
                            config.address2?.r ? [required] : [],
                          )}
                          hidden={config.address2?.h}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <Field
                          name="address.city"
                          type="text"
                          label="City"
                          component={InputText}
                          placeholder="Required"
                          required={config.city?.r}
                          validate={[].concat(config.city?.r ? [required] : [])}
                          hidden={config.city?.h}
                        />
                      </div>
                      <div className="col-6">
                        <Field
                          name="address.state"
                          type="text"
                          label="State / Province / Region"
                          component={InputText}
                          placeholder="Required"
                          required={config.state?.r}
                          validate={[].concat(
                            config.state?.r ? [required] : [],
                          )}
                          hidden={config.state?.h}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <Field
                          name="address.zipCode"
                          type="text"
                          label="Zip / Postal Code"
                          component={InputText}
                          required={config.zipCode?.r}
                          validate={[].concat(
                            config.zipCode?.r ? [required] : [],
                          )}
                          hidden={config.zipCode?.h}
                          placeholder="Zip code"
                        />
                      </div>
                      <div className="col-6">
                        <Field
                          name="address.country"
                          type="text"
                          label="Country"
                          component={InputText}
                          required={config.country?.r}
                          validate={[].concat(
                            config.country?.r ? [required] : [],
                          )}
                          placeholder="Country"
                          hidden={config.country?.h}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <Field
                          name="latitude"
                          type="number"
                          label="Latitude"
                          component={InputText}
                          placeholder="Latitude"
                          validate={[validateLatitude]}
                        />
                      </div>
                      <div className="col-6">
                        <Field
                          name="longitude"
                          type="number"
                          label="Longitude"
                          component={InputText}
                          placeholder="Longitude"
                          validate={[validateLongitude]}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <CoordinatesInput
                          address={address}
                          change={change}
                          latitude={latitude}
                          longitude={longitude}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

FirstScreen.propTypes = {
  // eslint-disable-next-line react/no-typos
  match: ReactRouterPropTypes.match.isRequired,
  // eslint-disable-next-line react/no-typos
  history: ReactRouterPropTypes.history.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  asyncValidate: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  addNextStep: PropTypes.func.isRequired,
  companyName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  config: PropTypes.object.isRequired,
  brandingColor: PropTypes.string,
  logoUrl: PropTypes.string,
  requireCoverage: PropTypes.bool,
  asyncValidating: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
  latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  address: addressPropTypes,
};
FirstScreen.defaultProps = {
  brandingColor: '8fc748',
  logoUrl: null,
  requireCoverage: false,
  latitude: null,
  longitude: null,
  address: null,
};

const selector = formValueSelector('WizardOrderForm');

const ReachFirstScreen = connect((state) => {
  const address = selector(state, 'address');
  const latitude = selector(state, 'latitude');
  const longitude = selector(state, 'longitude');

  return {
    latitude,
    longitude,
    address,
  };
})(FirstScreen);

export default reduxForm({
  form: 'WizardOrderForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  asyncValidate: coverageAreaValidation,
  asyncChangeFields: ['latitude', 'longitude'],
})(ReachFirstScreen);
